import React, { useState } from 'react';
import { lerConsentimento, salvarConsentimento } from '../utils/consentimento';
import { initializeAnalytics, trackPageView } from './analytics';
import './ConsentimentoCookies.css';

const ConsentimentoCookies = () => {
  const [escolha, setEscolha] = useState(lerConsentimento);

  if (escolha) return null;

  const decidir = (valor) => {
    salvarConsentimento(valor);
    setEscolha(valor);
    if (valor === 'aceito' && initializeAnalytics()) {
      trackPageView();
    }
  };

  return (
    <div className="cc-banner" role="dialog" aria-label="Consentimento de cookies">
      <p className="cc-texto">
        Usamos cookies de análise (Google Analytics) para entender o uso da plataforma, conforme a LGPD.
        Eles só são carregados se você aceitar.
      </p>
      <div className="cc-botoes">
        <button type="button" className="cc-btn cc-recusar" onClick={() => decidir('recusado')}>Recusar</button>
        <button type="button" className="cc-btn cc-aceitar" onClick={() => decidir('aceito')}>Aceitar</button>
      </div>
    </div>
  );
};

export default ConsentimentoCookies;
